import _ from 'lodash'
import { getComponentsByName } from '../../core/utils/KVdom'
import { convertPropClass2ClassObjectLike } from '../../core/utils/KProps'
import KPopover from '../popover'

export default {
  name: 'KDropdown',
  props: {
    trigger: {
      type: String,
      default: 'hover',
      validator: (value) => ['click', 'hover'].indexOf(value) !== -1,
    },
    placement: {
      type: String,
      validator: (value) => /^(top|bottom)(-(start|end))?$/.test(value),
      default: 'bottom-start',
    },
    popperClass: {
      // 自定义 popper 类，将作用于 popper 上面
      validator: (value) => _.isString(value) || _.isArray(value) || _.isObjectLike(value),
      // {}
      default() {
        return {}
      },
    },
    closeOnClick: {
      type: Boolean,
      default: true,
    },
    arrow: {
      type: Boolean,
      default: true,
    },
    widthEqualToReference: {
      type: Boolean,
      default: false,
    },
    adjustOnChange: {
      type: Boolean,
      default: false,
    },
    delayShow: {
      type: Number,
      default: 0,
    },
    blockPropagation: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
    }
  },
  computed: {
    popperClassObjectLike() {
      return _.assign(
        {
          'km-dropdown-menu-wrapper': true,
        },
        convertPropClass2ClassObjectLike(this.popperClass),
      )
    },
  },
  watch: {
    visible(visible) {
      this.$emit('visible', visible)

      if (this.dropdownMenu) {
        this.dropdownMenu.direction = _.startsWith(this.placement, 'top') ? 'top' : 'bottom'
        this.dropdownMenu.visible = visible
      }
    },
  },
  mounted() {
    const popover = getComponentsByName(this.$children, 'KPopover')[0].popperVM
    this.$nextTick(() => {
      this.dropdownMenu = getComponentsByName(popover.$children, 'KDropdownMenu')[0]
      this.dropdownMenu && this.dropdownMenu.$on('menu-item-click', this.handleItemClick)
    })
  },
  render() {
    const reference = this.$slots.default
    const dropdown = this.$slots.dropdown
    const footer = this.$slots.footer

    return (
      <KPopover
        popperClass={this.popperClassObjectLike}
        trigger={this.trigger}
        delayHide={this.trigger === 'hover' ? 200 : 0}
        placement={this.placement}
        arrow={this.arrow}
        widthEqualToReference={this.widthEqualToReference}
        value={this.visible}
        onInput={this.handleVisibleChange}
        onDestroy={this.handlePopperDestroy}
        adjustOnChange={this.adjustOnChange}
        delayShow={this.trigger === 'hover' ? this.delayShow : 0}
        blockPropagation={this.blockPropagation}
      >
        <template slot="reference">{reference}</template>
        {dropdown}
        {footer}
      </KPopover>
    )
  },
  methods: {
    handleItemClick(e, action, itemInstance) {
      if (itemInstance.disabled) {
        return
      }

      this.$emit('action', action, itemInstance, e)

      if (this.closeOnClick) {
        this.$nextTick(() => {
          this.visible = false
        })
      }
    },
    handleVisibleChange(value) {
      this.visible = value
    },
    handlePopperDestroy() {
    },
  },
}
